global.getUrlParam = function (name, url) {
	if (!url) {
		url = location.href;
	}
	name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(url);
	return results == null ? null : results[1];
};

global.getLang = function () {
	return $('html').attr('lang');
};

global.localize = function (obj) {
	if (typeof obj === 'object') {
		return obj[$('html').attr('lang')];
	}
};

$.fn.disableScroll = function () {
	window.oldScrollPos = $(window).scrollTop();

	$(window).on('scroll.scrolldisabler', function (event) {
		$(window).scrollTop(window.oldScrollPos);
		event.preventDefault();
	});
};

$.fn.enableScroll = function () {
	$(window).off('scroll.scrolldisabler');
};


/* modal window close */
$('.modal__close').click(function () {
	$(this).parents('.modal--overlay').hide();
});

$('.modal--overlay').click(function () {
	$(this).hide();
});

$('.modal__container').click(function (e) {
	e.stopPropagation();
});

(function () {
	objectFitPolyfill($('.tile__img img, .indicator .figure__content img, .figure--gradient .figure__content img, figure__img--cover, .news-item__img img, .description-card__img'));
})();

$(window).on("load", function () {
	objectFitPolyfill($('.tile__img img, .indicator .figure__content img, .figure--gradient .figure__content img, figure__img--cover, .news-item__img img, .description-card__img'));
});

window.addEventListener('resize', () => {
	objectFitPolyfill($('.tile__img img, .indicator .figure__content img, .figure--gradient .figure__content img, figure__img--cover, .news-item__img img, .description-card__img'));
});

global.isExists = target => {
    return typeof(target) != 'undefined' && target != null;
};


// WEBPACK FOOTER //
// ./frontend/components/core/core.js